
<template>
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <Button  label="Skapa ny" @click="createDetails()" icon="pi pi-plus" ></Button>
        <Button :label="inActiveBtnText" @click="showInactive()" icon="pi pi-eye" ></Button><br/><br/>
        <!--<Button  label="Synkronisera" class="p-button-danger" @click="onSynchronize()" icon="pi pi-times" ></Button>-->
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="table-responsive">
            <h2>{{ msg }}</h2>
         <table class="table-hover orderList" v-if="customers">
            <thead>
              <tr>
                <th v-for="customerSchemaField in activeColumns" :key="customerSchemaField.label">
                  {{customerSchemaField.label}}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="customer in filteredCustomers" :key="customer.id" v-on:click="customerDetails(customer)">
                <td v-for="customerSchemaField in activeColumns" :key="customerSchemaField.label">
                 {{customer.data[customerSchemaField.model]}}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Button from 'primevue/button'
export default {
  name: 'CustomerList',
  components: {
    Button
  },
  data () {
    return {
      msg: 'Kunder',
      customers: [],
      customerSchema: {},
      showFilteredCustomers: false,
      inActiveBtnText: 'Visa inaktiva'
    }
  },
  async mounted () {
    const response = await this.$http.get('/api/customers')
    this.customers = response.data.customers
    this.customerSchema = response.data.schema
  },
  computed: {
    activeColumns: function () {
      return this.customerSchema.groups && this.customerSchema.groups[0].fields.filter(function (c) {
        return c.showInList
      })
    },
    filteredCustomers () {
      if (this.showFilteredCustomers) {
        return this.customers.filter(function (customer) {
          if (customer.data.inActive === true) {
            return customer
          }
        })
      } else {
        return this.customers.filter(function (customer) {
          if (customer.data.inActive === null || customer.data.inActive === undefined || customer.data.inActive === false) {
            return customer
          }
        })
      }
    }
  },
  methods: {
    createDetails () {
      this.$router.push({ name: 'CustomerCreate', params: { schema: this.customerSchema } })
    },
    customerDetails (customer) {
      this.$router.push({ name: 'CustomerDetails', params: { id: customer.id, customer: customer } })
    },
    async onSynchronize (evt) {
      // evt.preventDefault()
      const data = await this.$http.post('/api/vismasync/customers', { customers: { sync: true } })
      console.log(data)
    },
    showInactive () {
      if (this.showFilteredCustomers) {
        this.showFilteredCustomers = false
        this.inActiveBtnText = 'Visa inaktiva'
      } else {
        this.showFilteredCustomers = true
        this.inActiveBtnText = 'Visa alla'
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Customers/CustomerList.vue